import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Typography,
  FormControl,
  TextField,
  Button,
  Rating,
  Autocomplete,
  RadioGroup,
  Radio,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import styles from "../../styles/common/filterAccordion.module.css";
import React, { useEffect, useState } from "react";
import { useAllChallengeNames, useAllFundNames } from "../../lib/hooks";
import { rangeToString } from "../../lib/util";

interface Props {
  setFundStatus: Function;
  formDataHandler: Function;
}

const max: number = 999999999999999999;

const ProposerFilter = (props: Props) => {
  const [fund_id, setFund_id] = useState<any[]>([]);
  const [challenge_id, setChallenge_id] = useState<any[]>([]);

  const {
    allChallengeNames,
    loading: allChallengeNameLoading,
    error: allChallengeNameError,
  } = useAllChallengeNames();

  let {
    loading: fundNameLoading,
    allFundNames,
    error: fundNamError,
  } = useAllFundNames();

  let challenge_dropDownOption =
    !fundNameLoading &&
    !allChallengeNameLoading &&
    allChallengeNameError === null &&
    fundNamError === null
      ? fund_id.length > 0
        ? allChallengeNames
            .filter((item) =>
              fund_id.map((item) => item.id).includes(item.fund_id)
            )
            .map((item) => {
              return {
                label: `${item.fund_name}:${item.challenge_name}`,
                id: item.challenge_id,
              };
            })
        : allChallengeNames.map((item) => {
            return {
              label: `${item.fund_name}:${item.challenge_name}`,
              id: item.challenge_id,
            };
          })
      : [];

  useEffect(() => {
    if (challenge_id.length > 0) {
      let newArr = challenge_id.filter((challenge) =>
        fund_id
          .map((item) => item.id)
          .includes(
            allChallengeNames.filter(
              (allChallenge) => allChallenge.challenge_id === challenge.id
            )[0]?.fund_id
          )
      );
      setChallenge_id(newArr);
    }
    //eslint-disable-next-line
  }, [fund_id.length]);

  // handle fund status change
  const [selectedFundStatus, setSelectedFundStatus] = useState<string>("All");
  const handleFundStatusChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSelectedFundStatus((event.target as HTMLInputElement).value);
  };

  useEffect(() => {
    props.setFundStatus(selectedFundStatus);
    //eslint-disable-next-line
  }, [selectedFundStatus]);

  const [rating, setRating] = useState<number>(1);
  const [requestedMin, setRequestedMin] = useState<any>(0);
  const [requestedMax, setRequestedMax] = useState<any>(max);
  const [requestedAmount, setRequestedAmount] = useState<string>(
    "[0," + max.toString() + "]"
  );
  const requestedHandler = (event: React.FormEvent) => {
    event.preventDefault();
    setRequestedAmount(rangeToString(requestedMin, requestedMax));
  };

  const [fundedMin, setfundedMin] = useState<any>(0);
  const [fundedMax, setfundedMax] = useState<any>(max);
  const [fundedAmount, setfundedAmount] = useState<string>(
    "[0," + max.toString() + "]"
  );
  const fundedHandler = (event: React.FormEvent) => {
    event.preventDefault();
    setfundedAmount(rangeToString(fundedMin, fundedMax));
  };

  const [proposalNumMin, setproposalNumMin] = useState<any>(0);
  const [proposalNumMax, setproposalNumMax] = useState<any>(max);
  const [proposalNumAmount, setproposalNumAmount] = useState<string>(
    "[0," + max.toString() + "]"
  );
  const proposalNumHandler = (event: React.FormEvent) => {
    event.preventDefault();
    setproposalNumAmount(rangeToString(proposalNumMin, proposalNumMax));
  };

  const [fundedProNumMin, setfundedProNumMin] = useState<any>(0);
  const [fundedProNumMax, setfundedProNumMax] = useState<any>(max);
  const [fundedProNumAmount, setfundedProNumAmount] = useState<string>(
    "[0," + max.toString() + "]"
  );
  const fundedProNumHandler = (event: React.FormEvent) => {
    event.preventDefault();
    setfundedProNumAmount(rangeToString(fundedProNumMin, fundedProNumMax));
  };

  useEffect(() => {
    props.formDataHandler({
      fund_id: fund_id.length === 0 ? "All" : fund_id.map((item) => item.id),
      challenge_id:
        challenge_id.length === 0 ? "All" : challenge_id.map((item) => item.id),
      average_rating: rating,
      amount_requested: requestedAmount,
      funded_amount: fundedAmount,
      funded_proposals: fundedProNumAmount,
      number_of_proposals: proposalNumAmount,
    });
    // eslint-disable-next-line
  }, [
    fund_id,
    challenge_id,
    rating,
    requestedAmount,
    fundedAmount,
    fundedProNumAmount,
    proposalNumAmount,
  ]);

  return (
    <div className={styles.div}>
      <Grid container className={styles.filterGrid}>
        <Grid item>
          <Typography variant="h5">Filter</Typography>
        </Grid>
      </Grid>

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Fund</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Autocomplete
            // autoComplete
            multiple={true}
            id="combo-box-demo"
            options={
              !fundNameLoading && fundNamError === null
                ? allFundNames.map((item) => {
                    return {
                      label: item.fund_name,
                      id: item.fund_id,
                    };
                  })
                : []
            }
            size={"small"}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event: any, newValue: any[] | null) => {
              // setValue(newValue);
              setFund_id(newValue as any[]);
              console.log(newValue);
            }}
            //  disableClearable
            value={fund_id}
            renderInput={(params) => (
              <TextField {...params} label="Select Funds" />
            )}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Challenge</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Autocomplete
            // autoComplete
            multiple={true}
            id="combo-box-demo"
            options={challenge_dropDownOption}
            size={"small"}
            onChange={(event: any, newValue: any[] | null) => {
              // setValue(newValue);
              setChallenge_id(newValue as any[]);
              console.log(newValue);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            //disableClearable
            value={challenge_id}
            renderInput={(params) => (
              <TextField {...params} label="Select Challenges" />
            )}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Proposal Status</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="All"
              name="radio-buttons-group"
              onChange={handleFundStatusChange}
            >
              <FormControlLabel value="All" control={<Radio />} label="All" />
              <FormControlLabel
                value="True"
                control={<Radio />}
                label="Funded"
              />
              <FormControlLabel
                value="False"
                control={<Radio />}
                label="Not Funded"
              />
            </RadioGroup>
          </FormControl>
        </AccordionDetails>
      </Accordion>

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Amount Requested</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={requestedHandler}>
            <FormControl
              size="small"
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "5px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <TextField
                type="number"
                id="outlined-basic"
                label="Min"
                variant="outlined"
                size="small"
                name="min"
                onChange={(event) => {
                  event.target.value
                    ? setRequestedMin(event.target.value)
                    : setRequestedMin(0);
                }}
              />
              <TextField
                type="number"
                id="outlined-basic"
                label="Max"
                variant="outlined"
                size="small"
                name="max"
                onChange={(event) => {
                  event.target.value
                    ? setRequestedMax(event.target.value)
                    : setRequestedMax(max);
                }}
              />
              <Button variant="contained" type="submit">
                Submit
              </Button>
            </FormControl>
          </form>
        </AccordionDetails>
      </Accordion>

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Funded Amount</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={fundedHandler}>
            <FormControl
              size="small"
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "5px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <TextField
                type="number"
                id="outlined-basic"
                label="Min"
                variant="outlined"
                size="small"
                name="min"
                onChange={(event) => {
                  event.target.value
                    ? setfundedMin(event.target.value)
                    : setfundedMin(0);
                }}
              />
              <TextField
                type="number"
                id="outlined-basic"
                label="Max"
                variant="outlined"
                size="small"
                name="max"
                onChange={(event) => {
                  event.target.value
                    ? setfundedMax(event.target.value)
                    : setfundedMax(max);
                }}
              />
              <Button variant="contained" type="submit">
                Submit
              </Button>
            </FormControl>
          </form>
        </AccordionDetails>
      </Accordion>

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Average Rating</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Rating
            name="simple-controlled"
            value={rating ? rating : 0}
            onChange={(event, newVal) => setRating(newVal as number)}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Number of Proposals</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={proposalNumHandler}>
            <FormControl
              size="small"
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "5px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <TextField
                type="number"
                id="outlined-basic"
                label="Min"
                variant="outlined"
                size="small"
                name="min"
                onChange={(event) => {
                  event.target.value
                    ? setproposalNumMin(event.target.value)
                    : setproposalNumMin(0);
                }}
              />
              <TextField
                type="number"
                id="outlined-basic"
                label="Max"
                variant="outlined"
                size="small"
                name="max"
                onChange={(event) => {
                  event.target.value
                    ? setproposalNumMax(event.target.value)
                    : setproposalNumMax(max);
                }}
              />
              <Button variant="contained" type="submit">
                Submit
              </Button>
            </FormControl>
          </form>
        </AccordionDetails>
      </Accordion>

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Funded Proposals</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={fundedProNumHandler}>
            <FormControl
              size="small"
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "5px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <TextField
                type="number"
                id="outlined-basic"
                label="Min"
                variant="outlined"
                size="small"
                name="min"
                onChange={(event) => {
                  event.target.value
                    ? setfundedProNumMin(event.target.value)
                    : setfundedProNumMin(0);
                }}
              />
              <TextField
                type="number"
                id="outlined-basic"
                label="Max"
                variant="outlined"
                size="small"
                name="max"
                onChange={(event) => {
                  event.target.value
                    ? setfundedProNumMax(event.target.value)
                    : setfundedProNumMax(max);
                }}
              />
              <Button variant="contained" type="submit">
                Submit
              </Button>
            </FormControl>
          </form>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ProposerFilter;
